import { type RouteLocationNormalized, type Router } from "vue-router";

export default async function (router: Router, route: RouteLocationNormalized) {
  await router.push({
    name: "notFound",
    params: { pathMatch: route.path.substring(1).split("/") },
    query: route.query,
    hash: route.hash,
  });
}
